import api from './api';

/**
 * Utility function to export data to CSV
 * @param {string} endpoint - API endpoint to fetch data from (e.g., '/export/products.csv')
 * @param {string} filename - Name of the file to download (without extension)
 * @param {Object} options - Additional options for the export
 * @returns {Promise} - Promise that resolves when export is complete
 */
export const exportToCSV = async (endpoint = '/export/products.csv', filename = 'export', options = {}) => {
  try {
    const { data } = await api.get(endpoint, { responseType: 'blob', ...options });
    const url = window.URL?.createObjectURL(new Blob([data], { type: 'text/csv' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}-${new Date()?.toISOString()?.split('T')?.[0]}.csv`;
    a?.click();
    window.URL?.revokeObjectURL(url);
    return { success: true };
  } catch (e) {
    console.error('Export failed', e);
    return { success: false, error: e };
  }
};

/**
 * Utility function to export data directly to CSV without API call
 * @param {Array} headers - Array of column headers
 * @param {Array} data - Array of data rows
 * @param {string} filename - Name of the file to download (without extension)
 * @returns {Object} - Result object with success status
 */
export const exportDataToCSV = (headers, data, filename = 'export') => {
  try {
    const escapeCell = (value) => {
      const stringValue = value === null || value === undefined ? '' : String(value);
      return `"${stringValue.replace(/"/g, '""')}"`;
    };
    const csvContent = [
      headers,
      ...data
    ].map(row => row.map(escapeCell).join(',')).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL?.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}-${new Date()?.toISOString()?.split('T')?.[0]}.csv`;
    a.click();
    window.URL?.revokeObjectURL(url);
    return { success: true };
  } catch (e) {
    console.error('Export failed', e);
    return { success: false, error: e };
  }
};